import { FC } from "react";
import Tab, { TabProps } from "@mui/material/Tab";
import Tooltip from "@mui/material/Tooltip";

interface TooltipTabProps extends TabProps {
  tooltip?: string;
  label: React.ReactNode;
}

export const TooltipTab: FC<TooltipTabProps> = ({ tooltip, ...tabProps }) => {
  const { disabled } = tabProps;
  if (disabled && tooltip) {
    return (
      <Tooltip title={tooltip}>
        <span>
          <Tab
            {...tabProps}
            sx={{
              "&.Mui-disabled": {
                color: "text.disabled",
                opacity: 0.6,
              },
            }}
          />
        </span>
      </Tooltip>
    );
  }

  return <Tab {...tabProps} />;
};
